import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import About from '../views/About';
import Order from '../views/Order';
import register from '../views/register';
import port from '../views/port';
import showPort from '../views/showPort';
// import file from '../views/file';
import myAppioment from '../views/myAppioment';
// import judgement from "../views/judgement";

Vue.use(VueRouter);
const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: '新冠病毒核酸检测预约通道'
        }
    },
    {
        path: '/about',
        name: 'about',
        component: About,
        meta: {
            title: '新冠病毒核酸检测预约通道'
        }
    },
    {
        path: '/order',
        name: 'order',
        component: Order,
        meta: {
            title: '新冠病毒核酸检测预约查询'

        }

    },
    {
        path: '/register',
        name: 'register',
        component: register,
        meta: {
            title: '新冠病毒核酸检测报告查询'
        }
    },
    {
        path: '/port',
        name: 'port',
        component: port,
        meta: {
            title: '新冠病毒核酸检测报告查询'
        }
    },
    {
        path: '/showPort',
        name: 'showPort',
        component: showPort,
        meta: {
            title: '新冠病毒核酸检测报告查询'
        }
    },
    {
        path: '/myAppioment',
        name: 'myAppioment',
        component: myAppioment,
        meta: {
            title: '预约查询'
        }

    },
    // {
    //     path: '/judgement',
    //     name: 'judgement',
    //     component: judgement,
    //     meta: {
    //         title: '我的预约'
    //     }
    //
    // }

];


const router = new VueRouter({
    routes
});

export default router;
